<div class="container">
  <img src="assets/images/empty-state.svg" alt="" />
  <div *ngrxLet="searchTerm$; let searchTerm" class="search-text">
    <ng-container *ngrxLet="areProfileFiltersSet$; let areProfileFiltersSet">
      <div class="search-text-title no-results" data-cy="no-results-warning">
        <div><img class="search-warning-icon" src="/assets/icons/warning-icon.svg" alt="" /></div>
        @if (areProfileFiltersSet) {
          <div>
            Keine Resultate @if (searchTerm) {
            <span>für "{{ searchTerm }}"</span>
          }
        </div>
      }
      @if (!areProfileFiltersSet) {
        <div class="no-hits-filter">Suchresultate eingeschränkt</div>
      }
    </div>
    @if (!areProfileFiltersSet) {
      <div class="help-text">
        Die Trefferliste wird durch deine Einstellungen eingeschränkt. Es werden möglicherweise nicht alle
        Resultate angezeigt.
        <button
          (click)="openProfileFiltersDialog($event)"
          class="filter-info-button"
          data-no-search
          >
          Einstellungen anpassen
        </button>
      </div>
    }
  </ng-container>
</div>
</div>
